import { ANALYTICS_EVENTS, DRAWERS, ENUMS, PRINT_CHECKOUT_SCREENS, ROUTES } from '../constants';
import { getLocal, setLocal } from '../local';
export default {
  computed: {
    page_loading: {
      get() {
        return this.$store.getters['config/page_loading'];
      },
      set(val) {
        this.$root.setPageLoading(!!val);
      }
    },
    findKpopDesignerLink() {
      return `${process.env.VUE_APP_WEB_URL}designers/kpop`;
    }
  },
  methods: {
    setLocal(key, val) {
      setLocal(key, val);
    },
    getLocal(key, val) {
      return getLocal(key, val);
    },
    getLocalHideAlert(key, val) {
      return this.getLocal(ENUMS.LOCAL.HIDE_ALERT.replace('[type]', key), val);
    },
    setLocalHideAlert(key, val) {
      return this.setLocal(ENUMS.LOCAL.HIDE_ALERT.replace('[type]', key), val);
    },

    getCampaignIdeasLink(id) {
      if (!id) {
        id = ENUMS.SNAILBLAST.CAMPAIGN_TYPE.LIST_PURCHASE;
      }
      return ROUTES.CAMPAIGN_IDEAS.PATH.replace(':id', id);
    },
    getOrdersLink(type) {
      if (!type) {
        type = 'all';
      }
      return ROUTES.ADMIN_ORDERS.PATH.replace(':orderType', type);
    },
    setBrandColor() {
      var primaryColor = this.$store.getters['user/master_account'].primaryColor;
      if (primaryColor && this.$portalMode()) {
        this.$vuetify.theme.themes.light.brand = primaryColor;
      }
    },

    openPrintCheckoutWithProject(project) {
      if (project.printable) {
        this.$store.dispatch('drawers/open', {
          drawerId: DRAWERS.PRINT_CHECKOUT,
          data: { projectId: parseInt(project.id), screen: PRINT_CHECKOUT_SCREENS.EDIT }
        });
      } else {
        var limitationMessage = project.isCustomSize
          ? 'project not printable (custom size)'
          : 'project not printable';
        this.$mixpanel.trackEvent(ANALYTICS_EVENTS.LIMITATION.NAME, null, {
          message: limitationMessage
        });
        this.$root.$alert(
          'Project Unprintable',
          'This product is not a standard MyCreativeShop size & is not printable from our online checkout. If you would like a custom quote please reach out to our support team.',
          { closeOnly: true }
        );
      }
    },

    goToLogin(query, returnUrl) {
      if (!query) {
        query = '';
      }
      if (!returnUrl) {
        returnUrl = window.location.href;
      }
      window.location = `${process.env.VUE_APP_WEB_URL}account/login?returnUrl=${encodeURIComponent(returnUrl)}&${query}`;
    },

    getRedirectInfo(local) {
      const acceptableRedirects = ['login', 'account_creation'];
      if (acceptableRedirects.includes(this.$route.query.redirectFrom) && this.$store.getters['user/authorized']) {
        return this.getLocal(local);
      }
      return null;
    },

    formatHtml(val) {
      return val.replaceAll('\n', '<br/>');
    }
  }
};
